module.exports = __webpack_public_path__ + "244ec5fd066160d51d3cf4367c86301f.jpg";